<template lang="pug">
div
  v-row.justify-end(style='position: fixed; z-index:0; bottom: 10px; right: 40px')
    v-btn( large color='rojo' icon @click='$vuetify.goTo("#navegador")').mb-6
      v-icon( large ) fa-chevron-up
  v-container(fluid style='position: relative; z-index:10;' ).pa-10.azul
    v-card.transparent( flat  )
      v-row.justify-end
        v-btn( color='rojo'  large icon @click='$vuetify.goTo("#navegador")').mb-6
          v-icon( large ) fa-chevron-up
      v-row( justify='center' align='end' )
        v-col(cols=12  md=4 )
          p.display-1.mb-0.text-uppercase.font-weight-light.white--text.icono-international.icono-grande( style='position: relative' v-html='pie_de_pagina.titulo').pt-7.pl-7
          p.display-1.text-uppercase.font-weight-bold.white--text( style='position: relative' v-html='pie_de_pagina.subtitulo').pl-7.mb-10 

          p.subtitle-1.font-weight-bold.white--text.text-uppercase(v-if='pie_de_pagina.contacto') {{pie_de_pagina.contacto.titulo}}
          p.mb-0.white--text.font-weight-bold(v-if='pie_de_pagina.contacto') {{pie_de_pagina.contacto.telefono}}
          p.white--text(v-if='pie_de_pagina.contacto') {{pie_de_pagina.contacto.correo}}
        
        v-col(cols=12 md=4 )
          v-row.justify-left.justify-md-center
            div.d-flex.flex-column
              template( v-for='{icono, titulo, vinculo}, i of navegador.redes_sociales')
                v-btn( v-if='titulo' text  elevation=0 :href='vinculo' color='white' target='_blank' )
                  v-row.justify-start
                    v-card(color='transparent' elevation=0 :href='vinculo' target='_blank' ).ml-3.px-0.mr-2
                      v-img(small color='white' width=25 height=25 :src='icono') 
                    span.caption.font-weight-bold {{titulo}}

        v-col(cols=12  md=4)
          
          template( v-for='{direccion, distrito, sector} of pie_de_pagina.direcciones')

            h4.text-uppercase.font-weight-bold.text-left.text-md-right.font-weight-regular.rojo--text {{distrito}}
            h4.text-left.text-md-right.font-weight-regular.white--text {{direccion }}
            h4.text-left.text-md-right.font-weight-regular.white--text {{sector}}
  v-container(fluid style='position: relative; z-index:10;').azul.darken-1
    v-col
      v-row.justify-space-between.align-center
        v-col( cols=12 md=6) 
          span.white--text.caption International Consumables 2020, Derechos reservados.
        v-col(cols=12 md=6)
          p.white--text.caption.text-center.text-md-right.mb-0 Desarrollado por 
            v-btn(color='white' target='_blank' href='https://www.facebook.com/mapeo.peru' text) Mapeo      
     


</template>
<script>
import { mapActions } from 'vuex'
export default {
  data: ()=>({
    drawer : false,
  }),
  computed: {
    pie_de_pagina() {
      return this.$contenido.pie_de_pagina || {}
    },
    navegador() {
      return this.$contenido.navegador || {}
    },
  },
  methods: {
    ...mapActions({
      suscribirse: 'Contacto/suscribirse',
    }),
  },
}
</script>